<div [class]="'thumbnail family-' + family" [class.by-project]="byProject">
  @if (kind === 'icon') {
    <mat-icon>{{ icon }}</mat-icon>
  } @else {
    <svg viewBox="0 0 120 72" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      @for (shape of shapes; track $index) {
        @switch (shape.tag) {
          @case ('rect') {
            <svg:rect [attr.class]="shape.cls" [attr.x]="shape.x" [attr.y]="shape.y" [attr.width]="shape.w" [attr.height]="shape.h"
              [attr.rx]="shape.rx" [attr.opacity]="shape.opacity" />
          }
          @case ('circle') {
            <svg:circle [attr.class]="shape.cls" [attr.cx]="shape.x" [attr.cy]="shape.y" [attr.r]="shape.r" [attr.opacity]="shape.opacity" />
          }
          @case ('text') {
            <svg:text [attr.class]="shape.cls" [attr.x]="shape.x" [attr.y]="shape.y">{{ shape.text }}</svg:text>
          }
          @default {
            <svg:path [attr.class]="shape.cls" [attr.d]="shape.d" />
          }
        }
      }
    </svg>
  }
</div>
